import { CommApiInstance } from "Utils/CommApiInstance";

const LnchStrtApi = async (
    gameSvcCd:any,
    mltSetYn:string|null
    
) => {
    return await CommApiInstance.post(`game/${gameSvcCd}/lnch_strt`,{
        apiBody:{
            mltSetYn:mltSetYn
        },
    })
    .then((Resp) => Resp.data);
}
export default LnchStrtApi;